import { render, staticRenderFns } from "./CustomerStatsPage.vue?vue&type=template&id=48f6441e&"
import script from "./CustomerStatsPage.vue?vue&type=script&lang=js&"
export * from "./CustomerStatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports